import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { translations } from "./translations";
import { projectConfig } from "@/config/project";

const LanguageContext = createContext(null);

const get = (obj, path) => path.split(".").reduce((o, k) => (o == null ? o : o[k]), obj);

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState(() => {
    try {
      const saved = localStorage.getItem("sln-lang");
      return saved && translations[saved] ? saved : "en";
    } catch {
      return "en";
    }
  });

  useEffect(() => {
    try {
      localStorage.setItem("sln-lang", lang);
    } catch {}
    document.documentElement.lang = lang === "zh" ? "zh-CN" : lang;
  }, [lang]);

  const fill = (v) => {
    if (typeof v === "string") return v.replaceAll("{address}", projectConfig.contractAddress);
    if (Array.isArray(v)) return v.map(fill);
    if (v && typeof v === "object") return Object.fromEntries(Object.entries(v).map(([k, val]) => [k, fill(val)]));
    return v;
  };

  const t = useCallback(
    (key) => {
      const value = get(translations[lang], key) ?? get(translations.en, key) ?? key;
      return fill(value);
    },
    [lang]
  );

  return <LanguageContext.Provider value={{ lang, setLang, t }}>{children}</LanguageContext.Provider>;
}

export const useLanguage = () => useContext(LanguageContext);
